import { isEmptyContentfulEntry } from "./contentful";

const navigateToUrl = (e, url) => {
	if (e) e.preventDefault();
	if (typeof window !== "undefined" && !isEmptyContentfulEntry(url)) {
		window.location.href = url;
	}
};

export default navigateToUrl;
